import { Component, input, OnChanges, OnInit, output, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'core-button',
  imports: [],
  templateUrl: './core-button.component.html',
  styleUrl: './core-button.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CoreButtonComponent implements OnInit, OnChanges {
  type = input<'button' | 'submit' | 'reset'>('button');
  mode = input<'primary' | 'error'>('primary');
  button_style = input<'basic' | 'flat' | 'stroked'>('basic');
  disable = input<boolean>(false);
  loading = input<boolean>(false);
  classList = {};

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.init();
  }

  onClick(event: Event): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.blur();

    if (this.disable() || this.loading()) {
      event.stopPropagation();
    }
  }

  private init() {
    this.classList = {
      primary: this.mode() === 'primary',
      error: this.mode() === 'error',
    };
  }
}
